import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { Input } from "../../common/components/Input"
import { ButtonLink, Button } from "buoy-core"

import { onSubmit as _onSubmit, onChange as _onChange } from "../handlers"

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const TextInput = styled(Input)`
  max-width: 360px;
  margin-bottom: 6px;
`

const Skip = styled(ButtonLink).attrs({
  color: "neutralDarkest",
  fontSize: "bodyMain",
})`
  margin-right: 32px;
`

const Actions = styled.div`
  margin: 6px 0 12px;
  display: flex;
`

const TextResponse = ({ item, value, onChange, onSkip, onKeydown, onSubmit, ...props }) => (
  <InputWrapper>
    <TextInput
      type="text"
      placeholder={item.placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={onKeydown}
    />
    <Actions>
      <Skip onClick={onSkip}>{item.skipText || "Skip"}</Skip>
      <Button disabled={!value} onClick={onSubmit}>
        Submit
      </Button>
    </Actions>
  </InputWrapper>
)

const mapStateToProps = (state, ownProps) => {
  switch (ownProps.item.type) {
    case "name":
      return {value: state.identifiers.name}
    case "employerCaptureInput":
      return {value: state.integration.employer}
    default:
      return {value: ""}
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const onSubmit = _onSubmit(ownProps.item, dispatch)
  const onChange = _onChange(ownProps.item, dispatch)

  return {
    onSubmit,
    onChange: e => onChange(e.target.value),
    onSkip: () => {
      onChange("")
      onSubmit()
    },
    onKeydown: e => {
      let key = e.keyCode || e.which
      if (key === 13) {
        onSubmit()
      }
    },
  }
}

const TextResponseWrapper = connect(mapStateToProps, mapDispatchToProps)(TextResponse)

export {TextResponseWrapper as default, TextResponse}



// WEBPACK FOOTER //
// ./assets/interview/components/TextResponse.js